import {
    RadioButtonList as UiRadioButtonList,
    styled,
    Typography,
} from "@l2r-front/l2r-ui"

export const ListSubheader = styled("div")(({ theme, variant }) => ({
    ...theme.typography?.[variant],
    alignItems: "center",
    display: "flex",
    gap: theme.spacing(2),
    color: theme.palette["primary"].main,
}))

export const RadioButtonList = styled(UiRadioButtonList)(({ theme }) => ({
    gap: theme.spacing(1),
    padding: theme.spacing(0, 5),
}))

export const Text = styled(Typography)({
    textAlign: "center",
})

export const AppTitle = styled(Typography)({
    textTransform: "uppercase",
})